module.exports = __webpack_public_path__ + "static/media/stars-less-768.2393a40b.webp";